export const validation = (yup) => ({
  cnpj: yup.string().required('Campo obrigatório'),
  user: yup.string().required('Campo obrigatório'),
  password: yup
    .string()
    .min(4, 'Deve conter no minimo 4 caracteres')
    .required('Campo obrigatório')
})
